import { MutableRefObject, useState } from "react"
import { NotVisibleIcon, VisibleIcon } from "themes/default-tailwind/icons"
import { AuthenticationInput } from "./inputs/AuthenticationInput"
import * as Icons from "@nova/component-icons"

type PasswordInput = {
    inputRef?: MutableRefObject<HTMLInputElement | null>
    id?: string
    name?: string
    autoComplete?: string
    maskPassword?: boolean
    placeHolder?: string
    changeHandler: (e: { target: { value: string; name: string } }) => void
    isDisabled?: boolean
    label?: string
    hideIcon?: boolean
}

export default function PasswordInput({
    inputRef,
    name = "password",
    autoComplete,
    id = "password",
    maskPassword: defaultMaskPassword = true,
    changeHandler,
    label = "Password*",
    isDisabled,
    hideIcon,
}: PasswordInput) {
    const [maskPassword, setMaskPassword] = useState(defaultMaskPassword)

    const MaskedIndicatorIcon = maskPassword ? NotVisibleIcon : VisibleIcon
    const inputType = maskPassword ? "password" : "text"
    return (
        <AuthenticationInput
            inputRef={inputRef}
            id={id}
            name={name}
            label={label}
            type={inputType}
            onChange={changeHandler}
            disabled={isDisabled}
            leftIcon={hideIcon ? undefined : Icons.HorizontalKey}
            rightIcon={MaskedIndicatorIcon}
            rightIconClickHandler={() => setMaskPassword(!maskPassword)}
            autoComplete={autoComplete}
        />
    )
}
